<template>
  <LandingPage v-if="isHomePath" />
  <NotFoundPage v-else />
</template>

<script>
import LandingPage from './components/LandingPage.vue';
import NotFoundPage from './components/NotFoundPage.vue';

export default {
  name: 'App',
  components: {
    LandingPage,
    NotFoundPage
  },
  computed:{
    isHomePath() {
      return ['/', '', '/index.html'].includes(window.location.pathname);
    }
  }
}

</script>

<style>

</style>
